import ChoosePlansView from '@/views/Subscription/ChoosePlansView.vue';
import ConfirmPlanView from '@/views/Subscription/ConfirmPlanView.vue';
import CreditPacksView from '@/views/Subscription/CreditPacksView.vue';
import SubscriptionCancelView from '@/views/Subscription/SubscriptionCancelView.vue';
import SubscriptionSuccessView from '@/views/Subscription/SubscriptionSuccessView.vue';

const subscriptionRoutes = [
  {
    path: '/subscription/success',
    name: 'subscription-success',
    meta: {
      headerConfig: {
        headerLabel: 'subscription',
        hide: false,
        showBack: false,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: false,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: SubscriptionSuccessView,
  },
  {
    path: '/subscription/cancel',
    name: 'subscription-cancel',
    meta: {
      headerConfig: {
        headerLabel: 'subscription',
        hide: false,
        showBack: false,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: SubscriptionCancelView,
  },
  {
    path: '/subscription/plans',
    name: 'subscription-plans',
    meta: {
      headerConfig: {
        headerLabel: 'plans',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true, // Set to true
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: ChoosePlansView,
  },
  {
    path: '/subscription/plans/:planId',
    name: 'subscription-plan-confirm',
    meta: {
      headerConfig: {
        headerLabel: 'plans',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: ConfirmPlanView,
  },
  {
    path: '/subscription/credits/purchase',
    name: 'subscription-credits-purchase',
    meta: {
      headerConfig: {
        headerLabel: 'creditPacks',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: CreditPacksView,
  },
];

export default subscriptionRoutes;
